// extracted by mini-css-extract-plugin
export default {"searchControls":"MusicHomeSearchControl_searchControls__X6zJU","isActiveOnMobile":"MusicHomeSearchControl_isActiveOnMobile__yvuRC"};